import { Logo } from '../../../components'
import Form from './form'

export default function SignUp() {
  return (
    <main className="w-screen min-h-screen py-10 md:py-6 flex flex-col items-center justify-center">
      <div className="px-6 md:w-[66%] lg:w-[56%]">
        <div className="mb-8">
          <div className="w-max max-w-full mx-auto">
            <Logo className="p-0 m-0" />
          </div>
          <h1 className="text-center">
            Ola, seja bem-vindo(a) a sua escola online de inglês
          </h1>
        </div>

        <Form />
      </div>
    </main>
  )
}
